import './ContentCard.scss';
import { FC, MouseEvent } from "react";
import { ContentItem } from "../../../GlobalTypes";

interface Props {
	item: ContentItem,
	isSelected: boolean,
	clickCallback: Function
}

const ContentCard: FC<Props> = (props: Props) => {

	const truncate = (str: string, length: number) => {
		return str.length > length ? str.substring(0, length - 3) + '...' : str;
	}

	const clickHandler = (event: MouseEvent<HTMLDivElement>) => {
		event.preventDefault();
		if (props.item.cant_vote) {
			alert(`Sorry, you can't vote for ${props.item.title} because you are listed as the director.`);
			return;
		} else if (props.isSelected) {
			return;
		}
		props.clickCallback(props.item.id)
	};

	return (
		<div className={`vote-option-card ${props.isSelected ? 'selected' : ''} ${props.item.cant_vote ? 'disabled': ''}`}
			 onClick={clickHandler}>
			<span className="image-wrapper">
				<img src={props.item.poster_url} alt={props.item.title} />
				{props.isSelected ? <span><span className='select-checkmark'>&nbsp;</span></span> : null}
			</span>
			<span className='content-title'>{props.item.title}</span>
			<p className='content-description'>{truncate(props.item.description, 100)}</p>
		</div>
	);
}

export default ContentCard;
